// extracted by mini-css-extract-plugin
module.exports = {"block":"General_block__2cw0T"};